import React, { useCallback, useState } from "react";
import { graphql, useMutation } from "react-relay";
import { LazyQueryNetworkBoundrary } from "../../../../../components/mobile/QueryNetworkBoundrary";
import {
  UserLoggedInNavigatorNavigationProp,
  UserLoggedInNavigatorRouteProp,
} from "../../../../../TopLevelNavigators/UserLoggedIn/UserLoggedInNavigatorParamList";
import { WAWidgetSizeToNoteSize } from "../../WidgetAdd/utils/WAWidgetSizeToNoteSize";
import { WidgetSizeT } from "../../localTypes/WidgetSizeT";
import { WANoteMutation } from "./__generated__/WANoteMutation.graphql";
import { useWANotePreviewQueryLoader } from "./useWANotePreviewQueryLoader";
import { WANotePreview } from "./WANotePreview";
import { withWebModal } from "@/src/TopLevelNavigators/UserLoggedIn/withWebModal";
import { WANoteComponent } from "./WANoteComponent";

type Props = {
  navigation: UserLoggedInNavigatorNavigationProp<"WidgetAddNote">;
  route: UserLoggedInNavigatorRouteProp<"WidgetAddNote">;
};

function InnerWANote(props: Props & { fetchKey: string }) {
  const [title, setTitle] = useState(props.route.params.title);

  const [createWidgetNote, loading] = useMutation<WANoteMutation>(graphql`
    mutation WANoteMutation($storecastId: ID!, $input: CreateWidgetNoteInput!) {
      dashboard(dashboardId: $storecastId) {
        createWidgetNote(widget: $input) {
          id
        }
      }
    }
  `);

  const onCreate = useCallback(
    (
      size: WidgetSizeT,
      pages: {
        currentValue: string;
        fontSize: any;
        fontStyle: any;
        includedInSlideshow: boolean;
        backgroundColor: string | null;
        remoteImageURL: string | undefined;
      }[]
    ) => {
      createWidgetNote({
        variables: {
          storecastId: props.route.params.storecastId,
          input: {
            positionX:
              props.route.params.position.x + props.route.params.position.c * 2,
            positionY: props.route.params.position.y,
            size: WAWidgetSizeToNoteSize(size),
            title,
            pages,
          },
        },
        onCompleted: () => props.navigation.pop(2),
      });
    },
    [
      createWidgetNote,
      props.route.params.storecastId,
      props.route.params.position.x,
      props.route.params.position.c,
      props.route.params.position.y,
      props.navigation,
      title,
    ]
  );

  const queryRef = useWANotePreviewQueryLoader(
    props.route.params.template ?? "empty",
    props.route.params.storecastId
  );

  return (
    <WANoteComponent
      dataPrefix="WANOTE"
      template={props.route.params.template}
      maxSize={props.route.params.maxSize}
      loading={loading}
      onCreate={onCreate}
      unitSize={props.route.params.unitSize}
      title={title}
      setTitle={setTitle}
      preview={
        queryRef ? (
          <WANotePreview queryRef={queryRef} clientTitle={title} />
        ) : null
      }
    />
  );
}

function WANoteC(props: Props) {
  return (
    <LazyQueryNetworkBoundrary>
      {(fetchKey) => <InnerWANote {...props} fetchKey={fetchKey} />}
    </LazyQueryNetworkBoundrary>
  );
}

export const WANote = withWebModal(WANoteC, true);
